
import React from "react";
import { Navigate, Outlet } from 'react-router-dom';
import { getCookieJson } from "../utils/cookie";
import { IAM_COOKIE_NAME } from "../settings/config";


const PublicRoute = () => {
    const iamCookie = getCookieJson(IAM_COOKIE_NAME);
    const isAuthenticated = iamCookie && iamCookie["access_token"] ? true : false;
    return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default PublicRoute;
